<template lang="pug">
	.delete-order(v-if="showed")
		.card
			.card-header Delete Order
			.card-body
				.card-fetching(v-show="!result && !error")
					.icon.fa.fa-spinner.fa-spin
				.card-confirmation(v-show="!error && result")
					span {{`Are you sure you want to delete this ${orderName}order?`}}
				.card-error(v-show="!result && error")
					span {{error}}
			.card-footer
				button.btn.btn-cancel(@click="hide") Cancel
				button.btn.btn-confirm(type="submit" @click="deleteOrder" :disabled="!result || error") Delete Order

</template>

<script>

import Screen from "@/mixins/screen";
import {Server} from "@/services/Server";

export default {
	name: 'OrderActionsDelete',
	mixins: [Screen],
	screen: {
		updateOn: [],
		events: {
			"Can Delete Order": function (error, success, orderId) {
				if (!this.order || !orderId || (this.order && this.order.id !== orderId)) {
					this.error = 'Order not found';
					return;
				}
				if (error) {
					this.error = error;
					return;
				}
				if (success) this.result = true;
			},

			"Delete Order Completed": function (error, success, orderId) {
				if (!this.order || !orderId || (this.order && this.order.id !== orderId)) {
					this.error = 'Order not found';
					return;
				}
				if (error) {
					this.error = error;
					return;
				}
				if (success) this.hide();
			}
		}
	},
	data() {

		this.Server = Server;

		return {
			order: {},
			result: false,
			error: false,
			orderName: ''
		}
	},
	methods: {
		collectData(event, order) {

			this.result = false;
			this.error = false;

			this.order = order;
			if (this.order && this.order.id) {
				Server.sendToSocket({
					CanDeleteOrder: {
						orderId: this.order.id
					}
				});
				this.orderName = `"${this.order.name}" `;
				return;
			}
			this.error = 'Order not found';
		},
		deleteOrder() {
			if (this.order && !this.error) {

				this.error = false;
				this.result = false;

				Server.sendToSocket({
					DeleteOrder: {
						orderId: this.order.id
					}
				});

			}
		}

	}
}

</script>

<style lang="sass">

.delete-order
	position: absolute
	z-index: 2000
	top: 0
	left: 0
	bottom: 0
	right: 0
	display: flex
	justify-content: center
	align-items: center

	>.card
		width: 400px

		>.card-footer
			display: flex
			flex-direction: row
			justify-content: space-between

		>.card-body
			display: flex
			flex-direction: column
			gap: 0.5em
			height: 100px

			>.card-error, >.card-confirmation
				margin: auto




</style>
